<template>
  <el-dialog
    v-if="dialogSwitch"
    :visible.sync="dialogSwitch"
    :close-on-click-modal="false"
    class="dialogBox"
    width="734px"
    :show-close="false"
    :modal-append-to-body="false">
    <svg class="closeIcon cursor" aria-hidden="true" @click="dialogSwitch = false">
      <use xlink:href="#icon-a-Property1shibai" />
    </svg>
    <h3 class="messageTitle">创建失败</h3>
    <div class="messageContent">
      <div class="error">   
        {{ error }}
      </div>
      <div class="membersBox">
        <a class="member" href="https://developer.huawei.com" target="_blank">华为开放平台</a>
        <a class="member" href="https://open.oppomobile.com" target="_blank">OPPO开放平台</a>
        <a class="member" href="https://dev.vivo.com.cn/home" target="_blank">vivo开放平台</a>
        <a class="member" href="https://dev.mi.com/console/app/newapp.html" target="_blank">小米开放平台</a>
      </div>
      <div class="confirm" @click="dialogSwitch = false">好的</div>
    </div>
  </el-dialog>
</template>

<script>
export default {
  props:['error'],
  data() {
    return {
      dialogSwitch: false,
    };
  },
  methods: {
    open(dialogSwitch) {
      this.dialogSwitch = dialogSwitch;
    },
  },
};
</script>

<style scoped lang="scss">
.dialogBox {
  /deep/ .el-dialog {
    border-radius: 10px;
  }
  .closeIcon {
    position: absolute;
    top: 16px;
    right: 16px;
    width: 30px;
    height: 30px;
  }
  .messageTitle {
    position: relative;
    margin-bottom: 40px;
    font-size: 20px;
    color: rgba(18, 18, 18, 1);
    text-align: center;
    &::after {
      content: "";
      position: absolute;
      bottom: -20px;
      left: 50%;
      transform: translateX(-50%);
      width: 73px;
      height: 6px;
      background: rgba(222, 208, 148, 1);
      border-radius: 3px;
    }
  }
  .messageContent {
    padding: 0 50px;
    padding-bottom: 30px;
    font-size: 16px;
    .error {
      margin: 10px 0;
      line-height: 24px;
      color: red;
    }
    .membersBox {
      display: flex;
      justify-content: space-evenly;
      padding: 20px;
      background-color: rgba(250, 250, 250, 1);
      .member {
        margin-left: 10px;
        color: #4285F5;
        text-decoration: underline;
        &:hover {
          color: #ded094;
        }
      }
    }
    .confirm {
      margin: 30px auto;
      width: 331px;
      height: 50px;
      background: rgba(255, 255, 255, 1);
      border: 1px solid rgba(0, 0, 0, 1);
      border-radius: 5px;
      text-align: center;
      line-height: 50px;
      font-size: 16px;
      color: #000;
      cursor: pointer;
      &:hover {
        background: #000;
        color: #fff;
      }
    }
  }
}

</style>
